window.surbhi = window.surbhi || {};

surbhi.config = {
  bpSmall: false,
  mediaQuerySmall: "screen and (max-width: " + 900 + "px)",
  isTouch:
    "ontouchstart" in window ||
    (window.DocumentTouch && window.document instanceof DocumentTouch) ||
    window.navigator.maxTouchPoints ||
    window.navigator.msMaxTouchPoints
      ? true
      : false,
};

surbhi.config.bpSmall = matchMedia(surbhi.config.mediaQuerySmall).matches;
matchMedia(surbhi.config.mediaQuerySmall).addListener(function (mql) {
  if (mql.matches) {
    surbhi.config.bpSmall = true;
    document.dispatchEvent(new CustomEvent("matchSmall"));
  } else {
    surbhi.config.bpSmall = false;
    document.dispatchEvent(new CustomEvent("unmatchSmall"));
  }
});
surbhi.utils = {
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },

  wrap: function (el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  },

  debounce: function (wait, callback, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) callback.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) callback.apply(context, args);
    };
  },
  throttle: function (limit, callback) {
    var waiting = false;
    return function () {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(function () {
          waiting = false;
        }, limit);
      }
    };
  },

  prepareTransition: function (el, callback) {
    el.addEventListener("transitionend", removeClass);

    function removeClass(evt) {
      el.classList.remove("is-transitioning");
      el.removeEventListener("transitionend", removeClass);
    }

    el.classList.add("is-transitioning");
    el.offsetWidth; // check offsetWidth to force the style rendering

    if (typeof callback === "function") {
      callback();
    }
  },

  compact: function (array) {
    var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  serialize: function (form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (
        !field.name ||
        field.disabled ||
        ["file", "reset", "submit", "button"].indexOf(field.type) > -1
      )
        return;
      if (field.type === "select-multiple") {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
      );
    });
    return arr.join("&");
  },
};
surbhi.delegate = {
  on: function (event, callback, options) {
    if (!this.namespaces)
      // save the namespaces on the DOM element itself
      this.namespaces = {};

    this.namespaces[event] = callback;
    options = options || false;

    this.addEventListener(event.split(".")[0], callback, options);
    return this;
  },
  off: function (event) {
    if (!this.namespaces) {
      return;
    }
    this.removeEventListener(event.split(".")[0], this.namespaces[event]);
    delete this.namespaces[event];
    return this;
  },
};

// Extend the DOM with these above custom methods
window.on = Element.prototype.on = surbhi.delegate.on;
window.off = Element.prototype.off = surbhi.delegate.off;

surbhi.a11y = {
  trapFocus: function (options) {
    var eventsName = {
      focusin: options.namespace ? "focusin." + options.namespace : "focusin",
      focusout: options.namespace
        ? "focusout." + options.namespace
        : "focusout",
      keydown: options.namespace
        ? "keydown." + options.namespace
        : "keydown.handleFocus",
    };

    // Get every possible visible focusable element
    var focusableEls = options.container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
    );
    var elArray = [].slice.call(focusableEls);
    var focusableElements = elArray.filter((el) => el.offsetParent !== null);

    var firstFocusable = focusableElements[0];
    var lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute("tabindex", "-1");
    options.elementToFocus.focus();

    document.documentElement.off("focusin");
    document.documentElement.on(eventsName.focusout, function () {
      document.documentElement.off(eventsName.keydown);
    });

    document.documentElement.on(eventsName.focusin, function (evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      document.documentElement.on(eventsName.keydown, function (evt) {
        _manageFocus(evt);
      });
    });

    function _manageFocus(evt) {
      if (evt.keyCode !== 9) return;
      /**
       * On the first focusable element and tab backward,
       * focus the last element
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }
  },
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.container) {
      options.container.removeAttribute("tabindex");
    }

    document.documentElement.off(eventName);
  },

  lockMobileScrolling: function (namespace, element) {
    var el = element ? element : document.documentElement;
    document.documentElement.classList.add("lock-scroll");
    el.on("touchmove" + namespace, function () {
      return true;
    });
  },

  unlockMobileScrolling: function (namespace, element) {
    document.documentElement.classList.remove("lock-scroll");
    var el = element ? element : document.documentElement;
    el.off("touchmove" + namespace);
  },
};

surbhi.Modals = (function () {
  function Modal(id, name, options) {
    var defaults = {
      close: ".js-modal-close",
      open: ".js-modal-open-" + name,
      openClass: "modal--is-active",
      closingClass: "modal--is-closing",
      bodyOpenClass: ["modal-open"],
      bodyOpenSolidClass: "modal-open--solid",
      bodyClosingClass: "modal-closing",
      closeOffContentClick: true,
    };

    this.id = id;
    this.modal = document.getElementById(id);

    if (!this.modal) {
      return false;
    }

    this.modalContent = this.modal.querySelector(".modal__inner");

    this.config = Object.assign(defaults, options);
    this.modalIsOpen = false;
    this.focusOnOpen = this.config.focusIdOnOpen
      ? document.getElementById(this.config.focusIdOnOpen)
      : this.modal;
    this.isSolid = this.config.solid;

    this.init();
  }

  Modal.prototype.init = function () {
    document.querySelectorAll(this.config.open).forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
      btn.addEventListener("click", this.open.bind(this));
    });

    this.modal.querySelectorAll(this.config.close).forEach((btn) => {
      btn.addEventListener("click", this.close.bind(this));
    });

    // Close modal if a drawer is opened
    document.addEventListener(
      "drawerOpen",
      function () {
        this.close();
      }.bind(this)
    );
  };

  Modal.prototype.open = function (evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.activeSource = evt.currentTarget.setAttribute(
        "aria-expanded",
        "true"
      );
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.modal.classList.add(this.config.openClass);

    document.documentElement.classList.add(...this.config.bodyOpenClass);

    if (this.isSolid) {
      document.documentElement.classList.add(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = true;

    surbhi.a11y.trapFocus({
      container: this.modal,
      elementToFocus: this.focusOnOpen,
      namespace: "modal_focus",
    });

    let openModal = new CustomEvent("modalOpen", { detail: this });

    document.dispatchEvent(openModal);
    document.dispatchEvent(new CustomEvent("modalOpen." + this.id));

    this.bindEvents();
  };

  Modal.prototype.close = function (evt) {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // Do not close modal if click happens inside modal content
    if (evt) {
      if (evt.target.closest(".js-modal-close")) {
        // Do not close if using the modal close button
      } else if (evt.target.closest(".modal__inner")) {
        return;
      }
    }

    // deselect any focused form elements
    document.activeElement.blur();

    this.modal.classList.remove(this.config.openClass);
    this.modal.classList.add(this.config.closingClass);

    document.documentElement.classList.remove(...this.config.bodyOpenClass);
    document.documentElement.classList.add(this.config.bodyClosingClass);

    window.setTimeout(
      function () {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (
          this.activeSource &&
          this.activeSource.getAttribute("aria-expanded")
        ) {
          this.activeSource.setAttribute("aria-expanded", "false").focus();
        }
      }.bind(this),
      500
    ); // modal close css transition

    if (this.isSolid) {
      document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = false;

    surbhi.a11y.removeTrapFocus({
      container: this.modal,
      namespace: "modal_focus",
    });

    document.dispatchEvent(new CustomEvent("modalClose." + this.id));

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function () {
    window.on(
      "keyup.modal",
      function (evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this)
    );

    if (this.config.closeOffContentClick) {
      // Clicking outside of the modal content also closes it
      this.modal.on("click.modal", this.close.bind(this));
    }
  };

  Modal.prototype.unbindEvents = function () {
    document.documentElement.off(".modal");

    if (this.config.closeOffContentClick) {
      this.modal.off(".modal");
    }
  };

  return Modal;
})();

surbhi.Drawers = (function () {
  function Drawers(id, name) {
    this.config = {
      id: id,
      close: ".js-drawer-close",
      open: ".js-drawer-open-" + name,
      openClass: "js-drawer-open",
      closingClass: "js-drawer-closing",
      activeDrawer: "drawer--is-open",
      namespace: ".drawer-" + name,
    };

    this.nodes = {
      page: document.querySelector("#MainContent"),
    };

    this.drawer = document.querySelector("#" + id);
    this.isOpen = false;

    if (!this.drawer) {
      return;
    }

    this.init();
  }

  Drawers.prototype = Object.assign({}, Drawers.prototype, {
    init: function () {
      // Setup open button(s)
      document.querySelectorAll(this.config.open).forEach((openBtn) => {
        openBtn.setAttribute("aria-expanded", "false");
        openBtn.addEventListener("click", this.open.bind(this));
      });

      this.drawer
        .querySelector(this.config.close)
        .addEventListener("click", this.close.bind(this));

      // Close modal if a drawer is opened
      document.addEventListener(
        "modalOpen",
        function () {
          this.close();
        }.bind(this)
      );
    },

    open: function (evt, returnFocusEl) {
      if (evt) {
        evt.preventDefault();
      }

      if (this.isOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        evt.currentTarget.setAttribute("aria-expanded", "true");
        this.activeSource = evt.currentTarget;
      } else if (returnFocusEl) {
        returnFocusEl.setAttribute("aria-expanded", "true");
        this.activeSource = returnFocusEl;
      }

      surbhi.utils.prepareTransition(
        this.drawer,
        function () {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this)
      );

      document.documentElement.classList.add(this.config.openClass);
      this.isOpen = true;

      surbhi.a11y.trapFocus({
        container: this.drawer,
        namespace: "drawer_focus",
      });

      document.dispatchEvent(new CustomEvent("drawerOpen"));
      document.dispatchEvent(new CustomEvent("drawerOpen." + this.config.id));

      this.bindEvents();
    },

    close: function (evt) {
      if (!this.isOpen) {
        return;
      }

      // Do not close if click event came from inside drawer
      if (evt) {
        if (evt.target.closest(".js-drawer-close")) {
          // Do not close if using the drawer close button
        } else if (evt.target.closest(".drawer")) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      surbhi.utils.prepareTransition(
        this.drawer,
        function () {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this)
      );

      document.documentElement.classList.remove(this.config.openClass);
      document.documentElement.classList.add(this.config.closingClass);

      window.setTimeout(
        function () {
          document.documentElement.classList.remove(this.config.closingClass);
          if (
            this.activeSource &&
            this.activeSource.getAttribute("aria-expanded")
          ) {
            this.activeSource.setAttribute("aria-expanded", "false");
            this.activeSource.focus();
          }
        }.bind(this),
        500
      );

      this.isOpen = false;

      surbhi.a11y.removeTrapFocus({
        container: this.drawer,
        namespace: "drawer_focus",
      });

      this.unbindEvents();
    },

    bindEvents: function () {
      // Clicking out of drawer closes it
      window.on(
        "click" + this.config.namespace,
        function (evt) {
          this.close(evt);
          return;
        }.bind(this)
      );

      // Pressing escape closes drawer
      window.on(
        "keyup" + this.config.namespace,
        function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this)
      );

      surbhi.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
    },

    unbindEvents: function () {
      window.off("click" + this.config.namespace);
      window.off("keyup" + this.config.namespace);

      surbhi.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
    },
  });

  return Drawers;
})();


function shouldShowReminder() {
  const lastShownTimestamp = localStorage.getItem('lastShownTimestamp');

  if (!lastShownTimestamp) {
    return true;
  }

  const lastShownDate = new Date(Number(lastShownTimestamp));
  const now = new Date();

  return now - lastShownDate >= 8 * 60 * 60 * 1000;
}

function newsletterPopup() {
  let instance = new surbhi.Modals('Newsletter-Popup');

  // FIX: Guard against missing modal element in the DOM
  if (!instance || !instance.modal) return;

  let marketingEl = document.getElementById(instance.id);
  if (!marketingEl) return;

  let marketing = JSON.parse(marketingEl.dataset.marketing);

  if (!marketing) return;

  if (shouldShowReminder()) {
    localStorage.setItem('lastShownTimestamp', Date.now().toString());
  } else {
    return;
  }

  setTimeout(() => {
    instance.open();
  }, 5000);
}

function showMenuOnHover() {
  let items = document.querySelectorAll('header-menu summary');

  if (!items) return;

  items.forEach(item => {
    let hasMouseOverOccurred = false;
    let parentDetails = item.parentElement;
    item.addEventListener('mouseover', function () {
      if (!hasMouseOverOccurred) {
        this.parentElement.setAttribute('open', '');
      }
    });

    parentDetails.addEventListener('mouseleave', function () {
      hasMouseOverOccurred = false;
      this.removeAttribute('open');
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  showMenuOnHover();
  newsletterPopup();
});